import { render, staticRenderFns } from "./CmgRewardsExtras.vue?vue&type=template&id=c4d42382&scoped=true&lang=pug&"
import script from "./cmg-rewards-extras.ts?vue&type=script&lang=ts&"
export * from "./cmg-rewards-extras.ts?vue&type=script&lang=ts&"
import style0 from "./CmgRewardsExtras.vue?vue&type=style&index=0&id=c4d42382&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d42382",
  null
  
)

export default component.exports